import { Component, OnInit, Inject } from '@angular/core';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from '../../../services/global.service';
import Utils from '../../utility';

@Component({
  selector: 'app-risk-tol-wizard',
  templateUrl: './risk-tol-wizard.component.html',
  styleUrls: ['./risk-tol-wizard.component.css']
})
export class RiskTolWizardComponent implements OnInit {

  data;
  riskToleranceQuestionnaire: FormGroup;
  riskToleranceAggrement: FormGroup;
  riskToleranceMail: FormGroup;
  
  constructor(public dialogRef: MatDialogRef<RiskTolWizardComponent>,
    @Inject(MAT_DIALOG_DATA) data, private globalService: GlobalService, private fb: FormBuilder) {
      console.log('RT passed', data);
      this.data = data;
  }

  ngOnInit() {
    //this.hasAnsweredRiskTolQuestionnaire = false;
    this.riskToleranceQuestionnaire = this.fb.group({
      levelOfInvestment: [(this.data.obj) ? this.data.obj.LvlOfInvestExpID : '', [Validators.required]],
      lengthOfInvestment: [(this.data.obj) ? this.data.obj.LngthOfInvestID : '', [Validators.required]],
      toleranceOfRisk: [(this.data.obj) ? this.data.obj.ToleranceOfRiskID : '', [Validators.required]],
      isRedeemAccount:[(this.data.obj) ? this.data.obj.NeedRedeemID : '', [Validators.required]],
    });

    //set the RT questionnaire
    /* var body = {
      ClientID: Number(localStorage.getItem("selectedClient"))
    };
    
    this.globalService.getClientRiskTolerance(body)
    .subscribe(
      risk => {     
        //console.log('from server', risk); 
        if(risk != null){   
            
          this.riskToleranceQuestionnaire.controls['levelOfInvestment'].setValue(risk.LvlOfInvestExpID);
          this.riskToleranceQuestionnaire.controls['lengthOfInvestment'].setValue(risk.LngthOfInvestID);
          this.riskToleranceQuestionnaire.controls['toleranceOfRisk'].setValue(risk.ToleranceOfRiskID);
          this.riskToleranceQuestionnaire.controls['isRedeemAccount'].setValue(risk.NeedRedeemID);
        }
      });   */
  }

  close(update): void {
    if(update){
      
      this.dialogRef.close(this.riskToleranceQuestionnaire.value);
    } else {
      this.dialogRef.close();
    }
  }
}
